import * as React from 'react';
import { YMap, useYMapsContext } from '@cian/frontend-ymaps-components';
import type { YMapProps, YMaps } from '@cian/frontend-ymaps-components/es/types/ymaps';

/**
 * `YMap`, у которой `location` применяется только при смене самого объекта, а не на каждом ре-рендере.
 *
 * Обёртка `reactify` Яндекса на каждом ре-рендере заново передаёт пропы в карту, а кнопки зума
 * (`YMapZoomControl`) меняют положение императивно через `map.update({ location })`. Без `useDefault`
 * любой ре-рендер посреди зума кнопками возвращал бы карту к `location` из пропа — карта дёргалась.
 * Колёсико и драг меняют камеру через поведения карты и проп не трогают, поэтому с ними конфликта нет.
 *
 * Использовать только внутри `YMapProvider`: `reactify` берётся из его контекста.
 */
export const YMapWithDefaultLocation = React.forwardRef<YMaps.YMap, YMapProps>(function YMapWithDefaultLocation(
  { location, ...props },
  ref,
) {
  const { reactify } = useYMapsContext();

  return <YMap ref={ref} location={reactify.useDefault(location, [location])} {...props} />;
});
